import type { LinkedWiki } from './wiki';

// 与 WorklogPresenter / Web::WorklogsController 的 props 契约一一对应。
// 后端改字段时这里必须同步改。

export const WORKLOG_TASK_TYPES = [
  'fix',
  'feature',
  'refactor',
  'docs',
  'config',
  'analysis',
  'chore',
  'other',
] as const;

export type WorklogTaskType = (typeof WORKLOG_TASK_TYPES)[number];

// 列表上的 Tag 文案。后端只存英文枚举，中文只在前端映射。
export const WORKLOG_TASK_TYPE_LABELS: Record<WorklogTaskType, string> = {
  fix: '修复',
  feature: '功能',
  refactor: '重构',
  docs: '文档',
  config: '配置',
  analysis: '分析',
  chore: '杂务',
  other: '其他',
};

// 列表档：不含 body_md，正文要单独取。
export interface WorklogSummary {
  id: number;
  slug: string;
  title: string;
  summary: string;
  task_type: WorklogTaskType;
  working_directory: string | null;
  completed_at: string;
  // 关联了几条任务。列表行显示它 —— 列表档不带 linked_tasks 本身（会 N+1），
  // 所以这里是计数缓存列的值。
  task_links_count: number;
}

// 这次会话干过的一条任务。字段只够渲染那一块 —— 后端刻意没有套整个
// TaskPresenter（它会递归子任务、算 spent_seconds，在这里全是无人读的负担）。
export interface LinkedTask {
  id: number;
  // 对外标识符，进 URL（/todo/:url_key）。整数 id 是写 task_ids 时用的，两个都要。
  url_key: string;
  title: string;
  // 单条日志页那个只读勾选框读它：一条日志最有回顾价值的就是「当时干的活后来完成没有」。
  completed: boolean;
  // human 人手动关联 / agent AI 写入。
  linked_by: 'human' | 'agent';
}

// 详情档。
export interface WorklogFull extends WorklogSummary {
  body_md: string | null;
  // 进了回收站的任务后端已经滤掉，不会出现在这里。
  linked_tasks: LinkedTask[];
  // 哪几页 wiki 来自/对应这次会话。
  linked_wikis: LinkedWiki[];
}

export interface WorklogFilterState {
  task_type: string | null;
  working_directory: string | null;
  search: string | null;
  // 服务端回显的是 WorklogQuery 规范化后的 ISO8601 串，不是用户输入的原格式——
  // 传 '2026-08-03' 会回显成完整时间戳（如 '2026-08-03T00:00:00.000Z'）。
  since: string | null;
  until: string | null;
  limit: number;
  offset: number;
}

export interface WorklogFilters extends WorklogFilterState {
  options: {
    task_types: WorklogTaskType[];
    working_directories: string[];
  };
}

export interface WorklogPageProps {
  worklogs: WorklogSummary[];
  total: number;
  filters: WorklogFilters;
}
